import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { CommonConfigService } from '../../../utils/common-config';
import { IMaskModule } from 'angular-imask';
import { Router } from '@angular/router';

@Component({
    selector: 'system-parameters',
    standalone: true,
    imports: [ButtonModule, FormsModule, TableModule, InputTextModule, IMaskModule],
    templateUrl: './system-parameters.component.html',
    styleUrl: './system-parameters.component.less',
})
export class SystemParametersComponent implements OnInit {
    constructor(
        private http: HttpClient,
        private commonConfigService: CommonConfigService,
        private router: Router
    ) {}
    initSystemParameters = [
        {
            hiringLocation: "Xi'an",
            ssi: '',
            extraSSI: '',
            markup: '',
        },
        {
            hiringLocation: 'ChengDu',
            ssi: '',
            extraSSI: '',
            markup: '',
        },
    ];
    percentMask = {};
    systemParameters: any[] = [];

    ngOnInit() {
        this.percentMask = this.commonConfigService.getPercentWithDecimalConfig();
        this.getSystem();
    }
    saveChanges() {
        let params = JSON.parse(JSON.stringify(this.systemParameters));
        for (let i = 0; i < 2; i++) {
            params[i].ssi = this.commonConfigService.formatPercentInput(params[i].ssi);
            params[i].extraSSI = this.commonConfigService.formatPercentInput(params[i].extraSSI);
            params[i].markup = this.commonConfigService.formatPercentInput(params[i].markup);
        }
        this.http
            .post(`${environment.apiUrl}/Configure/systemParams`, params, {
                withCredentials: true,
            })
            .subscribe({
                next: (res: any) => {
                    this.getSystem();
                },
                error: (err) => {
                    if (err.status === 401) {
                        this.router.navigate(['/configuration/sign-in']);
                    }
                },
            });
    }
    discardChanges() {
        let params = JSON.parse(JSON.stringify(this.initSystemParameters));
        for (let i = 0; i < 2; i++) {
            params[i].ssi = this.commonConfigService.formatPercentInput('0');
            params[i].extraSSI = this.commonConfigService.formatPercentInput('0');
            params[i].markup = this.commonConfigService.formatPercentInput('0');
        }
        this.http
            .post(`${environment.apiUrl}/Configure/systemParams`, params, {
                withCredentials: true,
            })
            .subscribe({
                next: (res: any) => {
                    if (res) {
                        this.getSystem();
                    }
                },
                error: (err) => {
                    if (err.status === 401) {
                        this.router.navigate(['/configuration/sign-in']);
                    }
                },
            });
    }

    getSystem() {
        this.http
            .get(`${environment.apiUrl}/Configure/systemParams`, {
                withCredentials: true,
                observe: 'response',
            })
            .subscribe({
                next: (res: HttpResponse<any>) => {
                    if (res.body.length == 0) {
                        this.systemParameters = this.initSystemParameters;
                    } else {
                        for (let i = 0; i < 2; i++) {
                            res.body[i].ssi = (res.body[i].ssi * 100).toString();
                            res.body[i].extraSSI = (res.body[i].extraSSI * 100).toString();
                            res.body[i].markup = (res.body[i].markup * 100).toString();
                        }
                        this.systemParameters = res.body;
                    }
                },
                error: (err) => {
                    if (err.status === 401) {
                        this.router.navigate(['/configuration/sign-in']);
                    }
                },
            });
    }
}
